var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCrossRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0 14C0 6.268 6.266 0 14 0c7.732 0 14 6.266 14 14 0 7.732-6.266 14-14 14-7.732 0-14-6.266-14-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8A94A2",
    d: "M14.077 13.37l3.22-3.221a.44.44 0 0 1 .63 0 .45.45 0 0 1 0 .628l-3.222 3.221 3.221 3.221a.44.44 0 0 1 0 .629.45.45 0 0 1-.628 0l-3.221-3.221-3.3 3.3a.44.44 0 0 1-.629 0 .45.45 0 0 1 0-.63l3.3-3.299-3.3-3.3a.44.44 0 0 1 0-.628.45.45 0 0 1 .63 0l3.299 3.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCrossRound);
export default __webpack_public_path__ + "static/media/delete-cross--round.6fae1b4a9989874f39f61e2b19809b6d.svg";
export { ForwardRef as ReactComponent };